import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { supabase } from "../lib/supabase";
import logo from "../assets/logo.png";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { session, profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const passwordUpdated = Boolean(location.state?.passwordUpdated);

  useEffect(() => {
    if (!session || !profile) return;
    const destination = profile.role === "admin" ? "/admin/issues" : profile.role === "member" ? "/member" : "/resident";
    navigate(destination, { replace: true });
  }, [session, profile, navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    if (signInError) setError(signInError.message || "Login failed.");
    setSubmitting(false);
  }

  return (
    <div className="screen centered">
      <form className="card form" onSubmit={handleSubmit}>
        <img src={logo} width="240" height="160" alt="Coach Homes III COA" className="login-logo" />
        <h1>Community Portal</h1>
        <p>Resident, board member, and administrator sign-in</p>
        {passwordUpdated ? <div className="success auth-message" role="status">Your password was updated. Sign in with your new password.</div> : null}
        {error ? <div className="error-block" role="alert">{error}</div> : null}
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        <button type="submit" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign In"}
        </button>
        <Link id="password-recovery-link" className="auth-help-link" to="/forgot-password">Forgot your password or need to create one?</Link>
        <div className="login-access-request">
          <span>Coach Homes III resident without an account?</span>
          <Link to="/request-resident-access">Request Resident Center access</Link>
          <span className="login-request-divider">New board member without a resident account?</span>
          <Link to="/request-access">Request a board-member account</Link>
          <span className="login-existing-account-note">Already have a resident account? Sign in and request the board role from the Resident Center—do not create a second account.</span>
        </div>
      </form>
    </div>
  );
}
